var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnBuyPreloved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#01A847",
    strokeWidth: 2,
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.83 30.457h-2.61l4.879 5.228L25.653 38 17 28.728l8.653-9.272 2.446 2.316-4.951 5.305h2.683c2.654 0 4.813-2.175 4.813-4.848 0-2.674-2.16-4.848-4.813-4.848h-4.233v3.833h-3.356V14h7.589C30.335 14 34 17.691 34 22.229c0 4.537-3.665 8.228-8.17 8.228",
    fill: "#01A847"
  }))));
}

export default SvgIcnBuyPreloved;